<template>
  <Layout style="height: 100%" class="main">
    <Spin size="large" fix v-if="spinShow"></Spin>
    <Sider
      hide-trigger
      collapsible
      :width="200"
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="$route.name"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <img v-show="!collapsed" :src="img_url" key="max-logo" />
          <img v-show="collapsed" :src="img_url" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <user
            :message-unread-count="unreadCount"
            :user-avator="userAvator"
            :user-name="userName"
          />
          <!-- <language v-if="$config.useI18n" @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/>
          <fullscreen v-model="isFullscreen" @showHomeFullScreen="showHomeFullScreen" style="margin-right: 10px;"/> -->
          <!--<messageCom style="margin-right: 10px;"></messageCom>-->
          <!--<shopCart style="margin-right: 10px;"></shopCart>-->
          <!-- <Card style="width:100px;">
          <div slot="title" class="login-con-header">
            <h3>{{$t('homeTitle')}}</h3>
           <language  @on-lang-change="setLocal" class="languageStyle" :lang="local"/>
          </div>
          </Card> -->
          <!-- <Card icon="log-in" :bordered="false" style="width:150px;">
            <div slot="title" class="login-con-header">
              <h3>{{$t('loginArea.title')}}</h3>
              <language v-if="config.useI18n" @on-lang-change="setLocal" class="languageStyle" :lang="local"/>
            </div>
          </Card> -->
          <div class="infoData">
            <Badge >
              <Icon type="md-notifications" size="28" @click="gotoinfo" />
            </Badge>
          </div>
          <div class="dpData">
            <Button @click="goHome">{{ $t("bigData") }}</Button>
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!-- <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div> -->
          <Content
            :class="{
              'content-wrapper': true,
              'content-wrapper-home': hasHomeBg,
            }"
            id="main-wrapper"
          >
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <ABackTop
              :height="100"
              :bottom="80"
              :right="50"
              container=".content-wrapper"
            ></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import ABackTop from "./components/a-back-top";
import messageCom from "./components/messageCom";
import Language from "./components/language";
import ErrorStore from "./components/error-store";
import { get_website_data } from "@/api/chuku";
import shopCart from "./components/shopCart";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, getNextRoute, routeEqual } from "@/libs/util";
import routers from "@/router/routers";
import minLogo from "@/assets/images/logo-min.png";
import maxLogo from "@/assets/images/logo-min.png";
import Fullscreen from "./components/fullscreen";
import routersArr from "../../router/routers"; //本地路由
import menuRoute from "@/router/module/menu";
import config from "@/config";
//import Language from '@/components/main/components/language'
//import { mapActions,mapMutations } from 'vuex'
import "./main.less";
export default {
  name: "Main",
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    ErrorStore,
    User,
    ABackTop,
    messageCom,
    shopCart,
    Fullscreen,
  },
  data() {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false,
      spinShow: false,
      config: config,
      img_url: null,
    };
  },
  computed: {
    ...mapGetters(["errorCount"]),
    hasHomeBg() {
      if (
        this.$route.name === "home" ||
        this.$route.name === "serviceReport" ||
        this.$route.name === "userHomeReport" ||
        this.$route.name === "productReport"
      ) {
        return true;
      } else {
        return false;
      }
    },
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvator() {
      //
      if (!this.$store.state.user.avatorImgPath) {
        return this.minLogo;
      }
      return this.$store.state.user.avatorImgPath;
    },
    userName() {
      return this.$store.state.user.userName;
    },
    cacheList() {
      return [
        "ParentView",
        ...(this.tagNavList.length
          ? this.tagNavList
              .filter((item) => !(item.meta && item.meta.notCache))
              .map((item) => item.name)
          : []),
      ];
    },
    menuList() {
      // let menu=menuRoute;
      // console.log(menu)
      // return menu;
      let menu = this.$store.getters.menuList;
      console.log("菜单", menu);
      for (let i = 0; i < routersArr.length; i++) {
        if (routersArr[i].name === "_home") {
          routersArr[i].children.push(...menu);
          break;
        }
      }
      this.$router.addRoutes(
        routersArr.concat([{ path: "*", redirect: "/404" }])
      );
      return menu;
    },

    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
  },
  methods: {
    gotoinfo(){
        const routeData = this.$router.push({
          // path: "/deviceman/detailsNew",detailsNbc
          path: "/infodata",
        });
        window.open(routeData.href, "_self");
    },
    ...mapMutations([
      "setBreadCrumb",
      "setTagNavList",
      "addTag",
      "setLocal",
      "setHomeRoute",
    ]),
    ...mapActions(["handleLogin", "handleGetMenu"]),
    goHome() {
      this.$router.push({
        name: "home",
      });
    },
    changeCallLoading(b) {
      this.spinShow = b;
    },
    turnToPage(route) {
      localStorage.setItem('country_code','xciot-prod-cnsz')
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query,
      });
    },
    handleCollapsedChange(state) {
      console.log("我的路径", state);

      this.collapsed = state;
      this.$store.commit("echartDomResize", state);
    },
    handleCloseTag(res, type, route) {
      if (type === "all") {
        this.turnToPage(this.$config.homeName);
      } else if (routeEqual(this.$route, route)) {
        if (type !== "others") {
          const nextRoute = getNextRoute(this.tagNavList, route);
          this.$router.push(nextRoute);
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    showHomeFullScreen() {
      let main = document.getElementById("main-wrapper");
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen();
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen();
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen();
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen();
        }
      }
    },
    checkFull() {
      let isFull =
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.webkitFullScreen ||
        document.msFullScreen;
      //to fix : false || undefined == undefined
      if (isFull === undefined) isFull = false;
      return isFull;
    },
  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: "push",
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    },
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers);
    // this.addTag({
    //   route: this.$route
    // })
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    // if (!this.tagNavList.find(item => item.name === this.$route.name)) {
    //   this.$router.push({
    //     name: this.$config.homeName
    //   })
    // }
    let vm = this;
    window.onresize = function () {
      if (!vm.checkFull()) {
        vm.$store.commit("setFullscreen", false);
      } else {
        vm.$store.commit("setFullscreen", true);
      }
    };
  },
  created() {
    get_website_data().then((res) => {
      this.img_url = `${
        process.env.NODE_ENV === "development"
          ? config.baseUrl.dev
          : process.env.VUE_APP_BUILD === "production"
          ? config.baseUrl.pro
          : config.baseUrl.alp
      }${res.body.logo_url}`;
    });
  },
};
</script>
<style scoped>
.dpData {
  margin-right: 10px;
}
.infoData {
  margin: 5px 15px 0 0;
  cursor: pointer;
}
.header-con {
  /* border-bottom:1px solid #dcdcdc;
    margin-bottom:2px; */
}
.content-wrapper {
  margin: 12px;
}
</style>
